import { Column } from "@faire/web--source/slate/Layout";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import styled from "styled-components";

import { CONTACT_CARDS_COMBINED_WIDTH } from "../../consts";

export const LimitedWidthWrapper = styled(Column).attrs({
  align: "flex-start",
})`
  ${responsiveMediaQueries.tabletAndAbove} {
    max-width: ${CONTACT_CARDS_COMBINED_WIDTH};
  }
  width: 100%;
`;
